import {
	DELETE_GEOFENCE,
	FETCH_V4_GEOFENCES,
	SAVE_GEOFENCE,
	SAVE_GEOFENCE_DEVICES,
	SET_DETAILED_GEOFENCE,
	V4_GEOFENCES_LOADED,
	V4_GEOFENCE_PRESENCE_CHANGED,
} from '../constants/geofence.constants';

export const setDetailedGeofence = geofence => ({ type: SET_DETAILED_GEOFENCE, geofence });
export const deleteGeofence = geofence => ({ type: DELETE_GEOFENCE, geofence });
export const saveGeofence = geofence => ({ type: SAVE_GEOFENCE, geofence});
export const saveGeofenceDevices = (geofence, devices, teamIds) => ({ type: SAVE_GEOFENCE_DEVICES, geofence, devices, teamIds });
export const fetchV4Geofences = () => ({ type: FETCH_V4_GEOFENCES });
// v4SiteMap: array of [v3SiteId, v4SiteUuid] pairs.
export const v4GeofencesLoaded = (geofences, v4SiteMap = []) =>
	({ type: V4_GEOFENCES_LOADED, geofences, v4SiteMap });
// Live presence update from the V4 websocket (entered/exited).
export const v4GeofencePresenceChanged = (geofenceId, deviceId, present) =>
	({ type: V4_GEOFENCE_PRESENCE_CHANGED, geofenceId, deviceId, present });
